import {
  GET_STATISTIC_FAIL,
  GET_STATISTIC_SUCCESS,
} from "../../actions/statistic/type";

const initialState = {
  statistics: {},
};
const statisticReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_STATISTIC_SUCCESS:
      return {
        ...state,
        statistics: payload,
      };
    case GET_STATISTIC_FAIL:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default statisticReducer;
